import { FC } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { AttendanceByPsychologistItem } from "src/apis/dashboardAttendance";
import ChartCard from "./ChartCard";
import { STATUS_COLORS } from "./constants";

type AttendanceByPsychologistChartProps = {
  data: AttendanceByPsychologistItem[];
};

const AttendanceByPsychologistChart: FC<AttendanceByPsychologistChartProps> = ({
  data,
}): JSX.Element => {
  const chartData = data
    .slice(0, 15)
    .map((item) => ({ ...item, name: item.psychologist_name ?? "—" }));

  return (
    <ChartCard title="Atendimentos por psicólogo" isEmpty={chartData.length === 0}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 8, right: 16, bottom: 0, left: -16 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" fontSize={11} interval={0} angle={-15} textAnchor="end" height={60} />
          <YAxis allowDecimals={false} fontSize={12} />
          <Tooltip />
          <Legend />
          <Bar dataKey="completed" name="Realizados" fill={STATUS_COLORS.completed} radius={[4, 4, 0, 0]} />
          <Bar dataKey="cancelled" name="Cancelamentos" fill={STATUS_COLORS.cancelled} radius={[4, 4, 0, 0]} />
          <Bar dataKey="no_show" name="Faltas" fill={STATUS_COLORS.no_show} radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};

export default AttendanceByPsychologistChart;
